import React from "react";
import { useDispatch } from "react-redux";
import { HeaderComp } from "../TambahPegawai/HeaderComp";
import {
  InputFieldResponsive,
  SelectFieldResponsive,
} from "../../component/Utils";
import DatePicker from "react-datepicker";
import { Label, Button, Form } from "reactstrap";
import { editDataAction } from "../../config/redux/action";
import {
  PG_NAMA,
  PG_NIK,
  PG_TEMPAT_LAHIR,
  PG_TANGGAL_LAHIR,
  PG_S1,
  PG_S2,
  PG_S3,
  PG_SMA,
  PG_SMP,
  PG_ALAMAT,
  PG_KELURAHAN,
  BASE_URL,
  PG_POSISI,
  PG_TINGKAT,
  PG_DIVISI,
  PG_DEPARTEMEN,
  PG_PERFORMA,
  PG_PENGEMBANGAN,
  PG_MULAIKERJA,
  PG_TALENT,
} from "../../constants";
import { useParams } from "react-router-dom";
import { Loader, Button as ButtonS } from "semantic-ui-react";
import Axios from "axios";
import { axiosConfig } from "../../utils/helper";
import {
  performance,
  talent,
  development,
  jenisKelamin,
} from "../Pegawai/LevelPegawai";
import LoadingTop from "../../component/LoadingTop";

const ActionButton = () => {
  const batal = (e) => {
    e.preventDefault();
    window.history.back();
  };
  return (
    <div className="d-flex justify-content-end">
      <Button type="button" className="mr-3" onClick={(e) => batal(e)}>
        Batal
      </Button>
      <ButtonS type="submit" color="blue">
        Simpan
      </ButtonS>
    </div>
  );
};

export default () => {
  const { idPegawai } = useParams();
  const dispatch = useDispatch();
  const [pegawai, setPegawai] = React.useState();
  const [provinsiList, setProvinsiList] = React.useState([]);
  const [kabupatenList, setKabupatenList] = React.useState([]);
  const [kecamatanList, setKecamatanList] = React.useState([]);
  const [kelurahanList, setKelurahanList] = React.useState([]);

  const init = () => {
    const urlPegawai = `${BASE_URL}/pegawai/${idPegawai}`;
    const config = axiosConfig();
    Axios.get(urlPegawai, config).then((response) => {
      const pg = { ...response.data };
      if (pg.kelurahanId && pg.kelurahanId.length > 7) {
        pg.provinsi = pg.kelurahanId?.substr(0, 2);
        pg.kabupaten = pg.kelurahanId?.substr(0, 4);
        pg.kecamatan = pg.kelurahanId?.substr(0, 7);
        changeProvinsi(pg.provinsi, true);
        changeKabupaten(pg.kabupaten, true);
        changeKecamatan(pg.kecamatan, true);
      }
      pg.tanggalLahir = pg.tanggalLahir ? new Date(pg.tanggalLahir) : null;
      pg.mulaiKerja = pg.mulaiKerja ? new Date(pg.mulaiKerja) : null;
      setPegawai({ ...pg });
      Axios.get(`${BASE_URL}/provinsi`, axiosConfig).then((r) =>
        setProvinsiList(r.data)
      );
    });
  };
  React.useEffect(() => {
    init();
  }, []);

  const handleChange = (event, type) => {
    const { name, value } = event.target;
    setPegawai({ ...pegawai, [name]: value });
    // dispatch({ type, data });
  };

  const handleChangeDate = (name, value, type) => {
    setPegawai({ ...pegawai, [name]: value });
    // if (type === PG_TANGGAL_LAHIR) setTanggalLahir(data);
    // dispatch({ type, data });
  };

  const changeProvinsi = (provinsiId, init = false) => {
    if (!init) setPegawai({ ...pegawai, provinsi: provinsiId });
    const url = `${BASE_URL}/kabupaten/provinsi/${provinsiId}`;
    Axios.get(url, axiosConfig()).then((r) => {
      setKabupatenList(r.data);
      if (!init) {
        setKecamatanList([]);
        setKelurahanList([]);
      }
    });
  };

  const changeKabupaten = (kabupatenId, init = false) => {
    const url = `${BASE_URL}/kecamatan/kabupaten/${kabupatenId}`;
    Axios.get(url, axiosConfig()).then((r) => {
      setKecamatanList(r.data);
      if (!init) {
        setKelurahanList([]);
      }
    });
  };

  const changeKecamatan = (kecamtanId, init = false) => {
    const url = `${BASE_URL}/kelurahan/kecamatan/${kecamtanId}`;
    Axios.get(url, axiosConfig()).then((r) => setKelurahanList(r.data));
  };

  const submit = (e) => {
    e.preventDefault();
    const param = {
      path: "pegawai",
      body: pegawai,
      title: "Pegawai",
    };
    dispatch(editDataAction(param)).then((response) => window.history.back());
  };

  // if (Object.keys(pegawai).length === 0 && pegawai.constructor === Object) {
  if (!pegawai) {
    return (
      <div className="w-100 d-flex justify-content-center my-5">
        <Loader active>Loading</Loader>
      </div>
    );
  }
  return (
    <>
      <LoadingTop />
      <HeaderComp title="Edit Pegawai" />
      <Form onSubmit={submit}>
        <div className="container mt-3">
          <div className="row">
            <div className="col-md-12">
              <div className="card container shadow-sm py-3 border-0">
                {/* <ActionButton /> */}
                <hr />
                <div className="mb-3">
                  <h4>Profile</h4>
                  <InputFieldResponsive
                    label="NIK *"
                    inputType={{
                      value: pegawai.nik,
                      disabled: false,
                      required: true,
                      name: "nik",
                    }}
                    onChange={(e) => handleChange(e, PG_NIK)}
                  />
                  <InputFieldResponsive
                    label="Nama Lengkap *"
                    inputType={{
                      value: pegawai.nama,
                      disabled: false,
                      required: true,
                      name: "nama",
                    }}
                    onChange={(e) => handleChange(e, PG_NAMA)}
                  />
                  <SelectFieldResponsive
                    value={pegawai.jenisKelamin}
                    label="Jenis Kelamin"
                    onChange={(e, v) =>
                      handleChangeDate("jenisKelamin", v.value)
                    }
                    inputType={{
                      options: jenisKelamin,
                    }}
                  />
                  <InputFieldResponsive
                    label="No. Telepon"
                    inputType={{
                      value: pegawai.telepon,
                      disabled: false,
                      name: "telepon",
                    }}
                    onChange={handleChange}
                  />
                  <InputFieldResponsive
                    label="Email"
                    inputType={{
                      value: pegawai.email,
                      disabled: false,
                      name: "email",
                    }}
                    onChange={handleChange}
                  />
                  <InputFieldResponsive
                    label="Tempat Lahir"
                    inputType={{
                      disabled: false,
                      name: "tempatLahir",
                      value: pegawai.tempatLahir || "",
                    }}
                    onChange={(e) => handleChange(e, PG_TEMPAT_LAHIR)}
                  />
                  <div className="row mb-2">
                    <div className="col-md-4 d-flex align-items-center">
                      <Label>Tanggal Lahir</Label>
                    </div>
                    <div className="col-md-8">
                      <DatePicker
                        selected={pegawai.tanggalLahir}
                        onChange={(date) =>
                          handleChangeDate(
                            "tanggalLahir",
                            date,
                            PG_TANGGAL_LAHIR
                          )
                        }
                        className="form-control"
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        maxDate={new Date()}
                        openToDate={new Date("1997/01/01")}
                      />
                    </div>
                  </div>
                </div>
                <div className="mb-3">
                  <h4>Alamat</h4>
                  <InputFieldResponsive
                    label="Alamat Lengkap"
                    onChange={(e) => handleChange(e, PG_ALAMAT)}
                    inputType={{
                      disabled: false,
                      type: "textarea",
                      name: "alamat",
                      value: pegawai.alamat || "",
                    }}
                  />
                  <SelectFieldResponsive
                    search
                    value={pegawai.provinsi}
                    onChange={(e, v) => changeProvinsi(v.value)}
                    label="Provinsi"
                    inputType={{
                      options: provinsiList.map((p) => ({
                        key: p.id,
                        value: p.id,
                        text: p.name,
                      })),
                    }}
                  />
                  <SelectFieldResponsive
                    search
                    value={pegawai.kabupaten}
                    label="Kota/Kabupaten"
                    onChange={(e, v) => changeKabupaten(v.value)}
                    inputType={{
                      options: kabupatenList.map((p) => ({
                        key: p.id,
                        value: p.id,
                        text: p.name,
                      })),
                    }}
                  />
                  <SelectFieldResponsive
                    search
                    value={pegawai.kecamatan}
                    label="Kecamatan"
                    onChange={(e, v) => changeKecamatan(v.value)}
                    inputType={{
                      options: kecamatanList.map((p) => ({
                        key: p.id,
                        value: p.id,
                        text: p.name,
                      })),
                    }}
                  />
                  <SelectFieldResponsive
                    search
                    value={pegawai.kelurahanId}
                    label="Kelurahan"
                    onChange={(e, v) =>
                      handleChangeDate("kelurahanId", v.value, PG_KELURAHAN)
                    }
                    inputType={{
                      options: kelurahanList.map((p) => ({
                        key: p.id,
                        value: p.id,
                        text: p.name,
                      })),
                    }}
                  />
                </div>
                <div className="mb-3">
                  <h4>Pendidikan</h4>
                  <InputFieldResponsive
                    label="SMP"
                    inputType={{
                      value: pegawai.smp || "",
                      disabled: false,
                      name: "smp",
                    }}
                    onChange={(e) => handleChange(e, PG_SMP)}
                  />
                  <InputFieldResponsive
                    label="SMA"
                    inputType={{
                      value: pegawai.sma || "",
                      disabled: false,
                      name: "sma",
                    }}
                    onChange={(e) => handleChange(e, PG_SMA)}
                  />
                  <InputFieldResponsive
                    label="S1"
                    inputType={{
                      value: pegawai.s1 || "",
                      disabled: false,
                      name: "s1",
                    }}
                    onChange={(e) => handleChange(e, PG_S1)}
                  />
                  <InputFieldResponsive
                    label="S2"
                    inputType={{
                      value: pegawai.s2 || "",
                      disabled: false,
                      name: "s2",
                    }}
                    onChange={(e) => handleChange(e, PG_S2)}
                  />
                  <InputFieldResponsive
                    label="S3"
                    inputType={{
                      value: pegawai.s3 || "",
                      disabled: false,
                      name: "s3",
                    }}
                    onChange={(e) => handleChange(e, PG_S3)}
                  />
                </div>
                <div className="mb-3">
                  <h4>Pekerjaan</h4>
                  <div className="row mb-2">
                    <div className="col-md-4 d-flex align-items-center">
                      <Label>Tanggal Masuk</Label>
                    </div>
                    <div className="col-md-8">
                      <DatePicker
                        selected={pegawai.mulaiKerja}
                        onChange={(date) =>
                          handleChangeDate("mulaiKerja", date, PG_MULAIKERJA)
                        }
                        className="form-control"
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        maxDate={new Date()}
                        openToDate={new Date("1997/01/01")}
                      />
                    </div>
                  </div>
                  <InputFieldResponsive
                    label="Posisi"
                    onChange={(e) => handleChange(e, PG_POSISI)}
                    inputType={{
                      value: pegawai.posisi || "",
                      disabled: false,
                      name: "posisi",
                    }}
                  />
                  <InputFieldResponsive
                    label="Tingkat"
                    onChange={(e) => handleChange(e, PG_TINGKAT)}
                    inputType={{
                      value: pegawai.tingkat || "",
                      disabled: false,
                      name: "tingkat",
                    }}
                  />
                  <InputFieldResponsive
                    label="Divisi"
                    onChange={(e) => handleChange(e, PG_DIVISI)}
                    inputType={{
                      value: pegawai.divisi || "",
                      disabled: false,
                      name: "divisi",
                    }}
                  />
                  <InputFieldResponsive
                    label="Departemen"
                    onChange={(e) => handleChange(e, PG_DEPARTEMEN)}
                    inputType={{
                      value: pegawai.departemen || "",
                      disabled: false,
                      name: "departemen",
                    }}
                  />
                  <SelectFieldResponsive
                    value={pegawai.performa}
                    label="Peforma"
                    onChange={(e, v) =>
                      handleChangeDate("performa", v.value, PG_PERFORMA)
                    }
                    inputType={{
                      options: performance,
                    }}
                  />
                  <SelectFieldResponsive
                    value={pegawai.bakat}
                    label="Bakat"
                    inputType={{ options: talent }}
                    onChange={(e, v) =>
                      handleChangeDate("bakat", v.value, PG_TALENT)
                    }
                  />
                  <SelectFieldResponsive
                    value={pegawai.pengembangan}
                    label="Pengembangan"
                    onChange={(e, v) =>
                      handleChangeDate("pengembangan", v.value, PG_PENGEMBANGAN)
                    }
                    inputType={{
                      options: development,
                    }}
                  />
                </div>
                <hr />
                <ActionButton />
              </div>
            </div>
          </div>
        </div>
      </Form>
    </>
  );
};
